import { lazy, Suspense } from 'react'
import Seo from '../components/Seo'
import Hero from '../sections/Hero'
import Project from '../sections/Project'
import Gites from '../sections/Gites'
import Orchards from '../sections/Orchards'
import Forest from '../sections/Forest'
import Discover from '../sections/Discover'

const Founders = lazy(() => import('../sections/Founders'))
const Newsletter = lazy(() => import('../sections/Newsletter'))
const Contact = lazy(() => import('../sections/Contact'))

export default function HomePage() {
  return (
    <>
      <Seo page="home" includeSiteGraph />
      <Hero />
      <Project />
      <Gites />
      <Orchards />
      <Forest />
      <Suspense fallback={null}>
        <Founders />
        <Discover />
        <Newsletter />
        <Contact />
      </Suspense>
    </>
  )
}